"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AGSearchBox_styles_1 = __importDefault(require("./AGSearchBox.styles"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var AGSearchBox = function () {
    return (react_1.default.createElement(AGSearchBox_styles_1.default, null,
        react_1.default.createElement(react_instantsearch_dom_1.SearchBox, { autoFocus: true, showLoadingIndicator: true, searchAsYouType: false, translations: {
                submitTitle: 'Zoekopdracht versturen',
                resetTitle: 'Zoekopdracht wissen',
                placeholder: 'Zoeken...',
            } })));
};
exports.default = AGSearchBox;
